export const API_BASE = process.env.REACT_APP_API_BASE;
export const AUTH_API_BASE = process.env.REACT_APP_AUTH_API_BASE;
export const IOT_API_BASE = process.env.REACT_APP_IOT_API_BASE;
export const THUMBNAILER_BASE = process.env.REACT_APP_THUMBNAILER_BASE;
export const DASHBOARD_APP_BASE = process.env.REACT_APP_DASHBOARD_APP_BASE;
export const PRERELEASE_DASHBOARD_APP_BASE = process.env.REACT_APP_PRERELEASE_DASHBOARD_APP_BASE;
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;
export const USE_SENTRY = process.env.REACT_APP_USE_SENTRY === 'true';
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const GOOGLE_TIMEZONE_API_KEY = process.env.REACT_APP_GOOGLE_TIMEZONE_API_KEY;

export const AVL_ENVIRONMENT = process.env.REACT_APP_AVL_ENVIRONMENT;
